export class TrayLine {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get positionOfFrontalAnswer() {
        return this.indexOfFrontalAnswer + 1;
    }
    get indexOfFrontalAnswer() {
        return this.app.history.historyAnswers.answersFinished.length;
    }
}
